<ng-container *ngIf="!type">
    <ui-license-dashboard [license]="license$ | async"
                          [editPermission]="['License.Create', 'License.Edit']"
                          [deletePermission]="['License.Delete']"
                          (remove)="onRemove($event)"
                          (upload)="onUpload($event)"
                          (online)="onOnlineActivate($event)"
                          (offline)="onOfflineActivate($event)"
                          (deactivated)="onOfflineDeactivate()"
                          (update)="onOnlineUpdate()">
    </ui-license-dashboard>
</ng-container>
<ng-container *ngIf="type">
    <ui-named-license *ngIf="officeType === officeTypeDefinition.FrontOffice"
                      [licenseType]="type">
    </ui-named-license>
    <ui-runtime-license *ngIf="officeType === officeTypeDefinition.BackOffice"
                        [licenseType]="type">
    </ui-runtime-license>
</ng-container>
